import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./assign.module.scss";
import { getFacilityLabel, renderValue } from "../../../utils";
import { setUpdateStatus } from "../../../app/customFormSlice";

const customerGroupText = {
  all: "All Customer",
  postacute: "Post-Acute",
  acute: "Acute",
};

const ViewAssign = () => {
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.forms.formDetailsData);
  const upDateStatus = useSelector((state) => state.forms.upDateStatus);
  const facilitiesData = useSelector((state) => state.forms.orgData);

  useEffect(() => {
    if (!upDateStatus?.status) return;
    const timeoutId = setTimeout(() => {
      dispatch(setUpdateStatus({}));
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, [dispatch, upDateStatus?.status]);

  const assignedFacilities = useMemo(() => {
    const soldToNumbers = formData?.assignInfo?.organization?.soldToNumbers || [];
    const facilities = facilitiesData?.data?.facilities || [];

    if (!soldToNumbers.length || !facilities.length) return [];

    const shipToSet = new Set(soldToNumbers.flatMap((s) => s.shipToNumbers));

    return facilities.filter((f) => shipToSet.has(f.facilityNumber));
  }, [formData, facilitiesData]);

  return (
    <>
      {upDateStatus && upDateStatus?.status === "success" && <div className={`alert alert-success ${styles.form_alert}`}>Successfully updated</div>}
      {upDateStatus && upDateStatus?.status === "error" && <div className={`alert alert-danger ${styles.form_alert}`}>Assign Form not update</div>}
      {formData?.assignInfo?.feature !== "NE1 WMS" && (
        <div className={`col-12 ${styles.col_spec}`}>
          <label className={`col-3 col-form-label ${styles.label_spec}`}>Customer Group Selection:</label>
          <div className="col-3 p-0">
            <span className={`col-form-label d-inline-block ${styles.content_spec}`}>
              {renderValue(customerGroupText?.[formData?.assignInfo?.customerGroup])}
            </span>
          </div>
        </div>
      )}
      {formData?.assignInfo?.feature === "Survey" && (
        <div className={`col-12 ${styles.col_spec}`}>
          <label className={`col-3 col-form-label ${styles.label_spec}`}>Email:</label>
          <div className="col-9 p-0">
            {Array.isArray(formData?.assignInfo?.userEmail) && formData.assignInfo.userEmail.length > 0 ? (
              <span className={`col-form-label ${styles.content_spec}`}>{formData.assignInfo.userEmail.join(", ")}</span>
            ) : (
              "-"
            )}
          </div>
        </div>
      )}
      <div className={`col-12 ${styles.col_spec}`}>
        <label className={`col-3 col-form-label ${styles.label_spec}`}>Customer Number:</label>
        <div className="col-3 p-0">
          <span className={`col-form-label d-inline-block ${styles.content_spec}`}>{renderValue(formData?.assignInfo?.customerNumber)}</span>
        </div>
      </div>
      <div className={`col-12 ${styles.col_spec}`}>
        <label className={`col-3 col-form-label ${styles.label_spec}`}>Organization:</label>
        <div className="col-7 p-0">
          {assignedFacilities.length > 0
            ? assignedFacilities.map((facility) => (
                <div key={facility.facilityNumber} className={`col-form-label ${styles.content_spec}`}>
                  {getFacilityLabel(facility)}
                </div>
              ))
            : "-"}
        </div>
      </div>
      <div className={`col-12 ${styles.col_spec}`}>
        <label className={`col-3 col-form-label ${styles.label_spec}`}>Feature:</label>
        <div className="col-3 p-0">
          <span className={`col-form-label d-inline-block ${styles.content_spec}`}>{renderValue(formData?.assignInfo?.feature)}</span>
        </div>
      </div>
      <div className={`col-12 ${styles.col_spec}`}>
        <label className={`col-3 col-form-label ${styles.label_spec}`}>Sub-Feature:</label>
        <div className="col-3 p-0">
          <span className={`col-form-label d-inline-block ${styles.content_spec}`}>{renderValue(formData?.assignInfo?.subFeature)}</span>
        </div>
      </div>
      <div className={`col-12 ${styles.col_spec}`}>
        <label className={`col-3 col-form-label ${styles.label_spec}`}>Sequence:</label>
        <div className="col-3 p-0">
          <span className={`col-form-label d-inline-block ${styles.content_spec}`}>{renderValue(formData?.assignInfo?.sequence)}</span>
        </div>
      </div>
    </>
  );
};

export default ViewAssign;
